module.exports = __webpack_public_path__ + "img/action-icon.32edae77.svg";